import { Modal, Button, Table } from "antd";

interface IProps {
  visualizar: boolean;
  setVisualizar: any;
}

export const ModalVisualizarSocializaciones: React.FC<IProps> = (props: IProps) => {

  const onCancel = () => {
    props.setVisualizar(false)
  }

  const datosTabla = [
    { actividad: "50-Palmitas Socialización convocatoria Estímulos PP 2026", fecha: "📆 06/03/2026", hora: "🕤 2:00 p.m.", lugar: "📍Biblioteca Público Corregimental San Sebastián de Palmitas" },
    { actividad: "Toda la ciudad - Socialización convocatoria Estímulos PP 2026", fecha: "📆 06/03/2026", hora: "🕤 10:00 a.m.", lugar: "📍Virtual" },
    { actividad: "Toda la ciudad - Socialización convocatoria Estímulos PP 2026", fecha: "📆 07/03/2026", hora: "🕤 9:00 a.m.", lugar: "📍Virtual" },
    { actividad: "Toda la ciudad - Socialización convocatoria Estímulos PP 2026", fecha: "📆 09/03/2026", hora: "🕤 6:30 p.m.", lugar: "📍Virtual" },
    { actividad: "13-San Javier Socialización convocatoria Estímulos PP 2026", fecha: "📆 10/03/2026", hora: "🕤 5:00 p.m.", lugar: "📍Parque Biblioteca Presbítero José Luis Arroyave, San Javier Cl. 42C #95 - 50" },
    { actividad: "Toda la ciudad - Socialización convocatoria Estímulos PP 2026", fecha: "📆 10/03/2026", hora: "🕤 6:30 p.m.", lugar: "📍Virtual" },
    { actividad: "10-La Candelaria Socialización convocatoria Estímulos PP 2026", fecha: "📆 11/03/2026", hora: "🕤 9:00 a.m.", lugar: "📍Edificio Vásquez, Cra. 52 #44-31" },
    { actividad: "10-La Candelaria Socialización convocatoria Estímulos PP 2026", fecha: "📆 12/03/2026", hora: "🕤 4:00 p.m.", lugar: "📍Museo Casa de la Memoria, Cl. 51 #36-6" },
    { actividad: "11-Laureles Socialización convocatoria Estímulos PP 2026", fecha: "📆 12/03/2026", hora: "🕤 3:00 p.m.", lugar: "📍CDS Laureles, AV 39 D #73 113, Segundo salón" },
    { actividad: "70-Altavista Socialización convocatoria Estímulos PP 2026", fecha: "📆 12/03/2026", hora: "🕤 4:00 p.m.", lugar: "📍Casa de la cultura Altavista" },
    { actividad: "90-Santa Elena Socialización convocatoria Estímulos PP 2026", fecha: "📆 13/03/2026", hora: "🕤 5:00 p.m.", lugar: "📍Auditorio Casa de la cultura Santa Elena" },
    { actividad: "9-Buenos Aires Socialización convocatoria Estímulos PP 2026", fecha: "📆 16/03/2026", hora: "🕤 3:00 p.m.", lugar: "📍Casa de la cultura Ávila, Cra. 29a # 38F -59" },
    { actividad: "3-Manrique Socialización convocatoria Estímulos PP 2026", fecha: "📆 19/03/2026", hora: "🕤 3:00 p.m.", lugar: "📍Museo Casa Gardeliana, Cra. 45 #76-50" },
    { actividad: "60-San Cristóbal Socialización convocatoria Estímulos PP 2026", fecha: "📆 12/03/2026", hora: "🕤 3:00 p.m.", lugar: "📍Parque Biblioteca Fernando Botero, Cl. 62 # 131-80" },
    { actividad: "Toda la ciudad - Socialización convocatoria Estímulos PP 2026", fecha: "📆 Del 16 al 20 de marzo", hora: "🕤9:00 a. m. a 12. y 2:00 p. m. a 4:00 p. m", lugar: "📍Algunos equipamientos de la Secretaría de Cultura Ciudadana" }
  ]

  const columns = [
    {
      title: "ACTIVIDAD",
      width: 450,
      dataIndex: "actividad",
      key: "actividad",
      render: (datos) => {
        return (
          <span style={{ whiteSpace: "pre-line" }}>
            {datos}
          </span>
        );
      },
    },
    {
      title: "FECHA",
      width: 200,
      dataIndex: "fecha",
      key: "fecha",
      render: (datos) => {
        return (
          <span style={{ whiteSpace: "pre-line" }}>
            {datos}
          </span>
        );
      },
    },
    {
      title: "HORA",
      width: 200,
      dataIndex: "hora",
      key: "hora",
      render: (datos) => {
        return (
          <span style={{ whiteSpace: "pre-line" }}>
            {datos}
          </span>
        );
      },
    },
    {
      title: "LUGAR",
      width: 400,
      dataIndex: "lugar",
      key: "lugar",
      render: (datos) => {
        return (
          <span style={{ whiteSpace: "pre-line" }}>
            {datos}
          </span>
        );
      },
    },
  ];

  return (
    <Modal
      className="ant-modal-close-x2"
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144 ,0.71)",
      }}
      visible={props.visualizar}
      onCancel={onCancel}
      width={1100}
      footer={[
        <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
          Cerrar
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div style={{ fontSize: '1.2em', textAlign: 'center' }}>
        <span className="pb-3 font-size-20px font-family-Montserrat-SemiBold">
          Socializaciones de portafolio 2026
        </span>
        <br />
        <div className="col-12">
          <Table
            style={{ borderTop: "1px solid #C4C4C4", fontSize: '16px' }}
            pagination={false}
            columns={columns}
            dataSource={datosTabla}
            size="middle"
            bordered={false}
            onRow={(record) => {
              return {
                style: {
                  cursor: 'pointer',
                },
              }
            }}
          />
        </div>
      </div>
    </Modal>
  );
};
